import {useCallback, useEffect, useState} from "react";
import {ICase} from "../../../types/Case";
import {getCaseByUserLineId} from "../api/getCaseByUserLineId";

type UseCaseByUserLineIdParams = {
  token: string;
  id: string | number;
}

export const useCaseByUserLineId = ({
  token,
  id
}: UseCaseByUserLineIdParams) => {
  const [caseData, setCaseData] = useState<ICase | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const fetchCase = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const data = await getCaseByUserLineId({ token, id });
      setCaseData(data);
    } catch (error) {
      setError(error?.message || 'error fetching cases');
    } finally {
      setLoading(false);
    }
  }, [token, id]);

  useEffect(() => {
    if (!token) return
    if (!id) return
    fetchCase();
  }, [token, id])

  return { caseData, loading, error }
}
